import { useSheetStore } from '@/shared/stores/sheet-store';

import type { ScheduleSessionClient } from './schedule-session-form.schema';

// A plain function, not a hook, so every entry point can call it straight from a click handler.
export function openScheduleSession(client?: ScheduleSessionClient) {
    useSheetStore.getState().openSheet({
        type: 'sessions/schedule',
        label: 'New Session',
        data: { client },
    });
}
